var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.553 19.125c0 1.3-1.084 2.313-2.313 2.313h-2.312L37 33v1.734c0 1.663-1.3 2.891-2.89 2.891h-5.782c-1.662 0-2.89-1.228-2.89-2.89v-6.36c0-1.229-1.084-2.313-2.313-2.313H18.5c-1.3 0-2.313 1.084-2.313 2.313v6.359c0 1.663-1.3 2.891-2.89 2.891H7.516c-1.662 0-2.891-1.228-2.891-2.89V21.437H2.312A2.283 2.283 0 0 1 0 19.125c0-.65.217-1.229.723-1.734l18.5-16.188c.506-.506 1.084-.578 1.59-.578.505 0 1.084.145 1.517.506l18.428 16.26c.578.506.867 1.084.795 1.734Z",
    fill: "#3C8047"
  })));
};
export default SvgHome;